module.exports = __webpack_public_path__ + "static/media/myAvatar.91d3bcdb.png";